export const isEven = (n: number): boolean => n % 2 === 0;
